/**
 * Created by iamso on 13.07.2020.
 */

cleverapps.styles.COLORS = cleverapps.overrideColors(cleverapps.styles.COLORS, {
    HINT_ALARM_COLOR: new cc.Color(150, 150, 150, 255),
    DARK_BROWN: new cc.Color(80, 60, 35, 255),
    LIGHT_BROWN: new cc.Color(157, 71, 57),
    DARK_GRAY: new cc.Color(77, 74, 72)
});

cleverapps.overrideFonts(cleverapps.styles.DECORATORS, {
    REWARDS_TEXT_STROKE: {
        color: cleverapps.styles.COLORS.DARK_BROWN,
        size: 3
    },
    WHITE_TEXT_STROKE: {
        color: cleverapps.styles.COLORS.BLACK,
        size: 2
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    LEVEL_TITLE_TEXT: {
        name: "default",
        size: 45
    },

    LEVEL_CURRENT_TITLE_TEXT: {
        size: 45,
        name: "default"
    },

    LEVEL_NOT_PASSED_TITLE_TEXT: {
        size: 45,
        name: "default"
    },
    LIGHTNING_RUSH_MARKS_TEXT: {
        name: "nostroke",
        color: cleverapps.styles.COLORS.DARK_BROWN
    },

    KINGSCUP_MARKS_TEXT: {
        name: "nostroke",
        color: cleverapps.styles.COLORS.DARK_BROWN
    },

    REWARDS_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.REWARDS_TEXT_STROKE
    },

    BACKGROUNDS_WINDOW_TAPE_TEXT: {
        size: 33,
        color: cleverapps.styles.COLORS.WHITE
    },
    TOURNAMENT_PLAYER_TEXT: {
        size: 23,
        color: cleverapps.styles.COLORS.WHITE
    }

});

if (cleverapps.styles.LightningRushMarksView) {
    cleverapps.overrideStyles(cleverapps.styles.LightningRushMarksView, {
        width: 200,
        height: 82,

        icon: {
            x: { align: "left", dx: -10 },
            width: 80
        },

        position: [
            {
                x: { align: "left", dx: 40 },
                y: { align: "top", dy: -280 }
            },
            {
                x: { align: "left", dx: 40 },
                y: { align: "bottom", dy: 80 }
            },
            {
                x: { align: "left", dx: 40 },
                y: { align: "bottom", dy: 60 }
            }
        ]
    });
}

cleverapps.overrideStyles(cleverapps.styles.ProgressView, {
    arrows: {
        y: { align: "center", dy: 6 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.GridPlayerNameView, {
    offsetY: 90
});

cleverapps.overrideStyles(cleverapps.styles.MinimalDialogue, {
    maxWidth: 1500
});

cleverapps.overrideStyles(cleverapps.styles.KnockoutPlayersView, {
    user: [
        { x: { align: "left", dx: 0 }, y: { align: "top", dy: -125 } },
        { x: { align: "left", dx: 0 }, y: { align: "top", dy: -150 } },
        { x: { align: "left", dx: 0 }, y: { align: "top", dy: -150 } }
    ],

    opponent: [
        { x: { align: "right", dx: 0 }, y: { align: "top", dy: -125 } },
        { x: { align: "right", dx: 0 }, y: { align: "top", dy: -150 } },
        { x: { align: "right", dx: 0 }, y: { align: "top", dy: -150 } }
    ],

    vertical: true
});
